import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { ITagField } from '../../../../types';
import { BaseTagFieldCard } from '../../../../styled';

interface OriginalTagFieldProps {
  field: ITagField;
}

export const OriginalTagField: FC<OriginalTagFieldProps> = () => (
  <BaseTagFieldCard>
    <SText style={{ width: '100%', textAlign: 'center' }}>
      No keywords available
    </SText>
  </BaseTagFieldCard>
);
